var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pill-badge",class:_vm.klassen,style:(_vm.farben)},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }